import { render, staticRenderFns } from "./LeftTree.vue?vue&type=template&id=3958573a&scoped=true&"
import script from "./LeftTree.vue?vue&type=script&lang=js&"
export * from "./LeftTree.vue?vue&type=script&lang=js&"
import style0 from "./LeftTree.vue?vue&type=style&index=0&id=3958573a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958573a",
  null
  
)

export default component.exports